import React from "react";
import { useGlobalElements } from "../../../services/app-state";
import { PullUpSection } from "../PullUpSection";

interface Props {
    topColor?: string;
    bottomColor?: string;
}

export const NotSureWhereToBegin: React.FC<Props> = props => {
    const [{ not_sure_where_to_begin }] = useGlobalElements();
    const { button, title, copy } = not_sure_where_to_begin;

    return (
        <PullUpSection
            topColor={props.topColor}
            bottomColor={props.bottomColor}
            title={title}
            description={copy}
            button={button}
            removeExtraBottomSpacing
        />
    );
};
